import { Component, OnInit } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { Calendar, Location, Query, CoreLibService } from 'core-lib';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from 'projects/appointment-module/src/environments/environment';

@Component({
    selector: 'lib-appointment-filter-settings',
    templateUrl: './appointment-filter-settings.component.html',
    styleUrls: ['./appointment-filter-settings.component.scss'],
    standalone: false
})
export class AppointmentFilterSettingsComponent implements OnInit {
  calendars: Calendar[] = [];
  selectedCalendarIds: string[] = [];
  filterMyEvents = false;
  filterOnlyWithFreeSignUpSlots = false;
  dontFilterUpcomingEvents = false;
  onlyShowFavorites = false;
  locations: Location[] = [];
  selectedLocationIds: string[] = [];
  apiURL = environment.apiURL;
  allSelected: boolean = true;
  resetFilter: boolean = false;
  isFilterActive: boolean = false;
  firstLoad = true;


  LOAD_LOCATIONS = gql`
  query locationQuery{
    listLocations{
      id
      title
      postalCode
      street
      city
      geoLat
      geoLng
    },
  }`;

  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef, private apollo: Apollo, public coreLibService: CoreLibService) {
    this.calendars = config.data.calendars;
    this.selectedCalendarIds = config.data.selectedCalendarIds;
    this.selectedLocationIds = config.data.selectedLocationIds;
    this.filterMyEvents = config.data.filterMyEvents;
    this.filterOnlyWithFreeSignUpSlots = config.data.filterOnlyWithFreeSignUpSlots;
    this.dontFilterUpcomingEvents = config.data.dontFilterUpcomingEvents;
    this.onlyShowFavorites = config.data.onlyShowFavorites;
    this.isFilterActive = config.data.isFilterActive;
  }

  ngOnInit(): void {
    this.apollo.query<Query>({
      query: this.LOAD_LOCATIONS,
    }).subscribe((result) => {
      this.locations = result.data.listLocations;

      //Sort Locations alphabetically
      this.locations.sort(function(a, b) {
        var textA = a.title.toUpperCase();
        var textB = b.title.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    });
  }

  ngAfterViewChecked(): void {
      if(this.firstLoad) {
        /*if(this.coreLibService.isNativeIOS()) {
          this.hideElementsOnIOS()
        }*/

        let elem = document.getElementById("additionalSettingsPanel")?.querySelectorAll("h3")[0] as HTMLElement;

        if (elem != null) {
          elem?.focus();

          this.firstLoad = false;
        }
      }
  }

  onSave(): void {
    if(this.resetFilter){
        this.onResetFilter();
    }
    if(this.selectedCalendarIds == null) {
        this.selectedCalendarIds = []
    }
    this.ref.close({
      filterMyEvents: this.filterMyEvents,
      selectedCalendarIds: this.selectedCalendarIds,
      selectedLocationIds: this.selectedLocationIds,
      filterOnlyWithFreeSignUpSlots: this.filterOnlyWithFreeSignUpSlots,
        dontFilterUpcomingEvents: this.dontFilterUpcomingEvents,
        onlyShowFavorites: this.onlyShowFavorites
    })
  }

  toggleAll(event: any) {
    if (event.checked) {
        this.selectedCalendarIds = this.calendars.map(c => c.id);
    } else {
        this.selectedCalendarIds = [];
    }
  }

    onSelectionChange() {
      // Überprüfen, ob alle ausgewählt sind
      this.allSelected = this.selectedCalendarIds.length === this.calendars.length;
    }

    onResetFilter():void{
        this.selectedCalendarIds = this.calendars.map(c => c.id);
        this.filterMyEvents = false;
        this.selectedLocationIds = [];
        this.filterOnlyWithFreeSignUpSlots = false;
        this.dontFilterUpcomingEvents = false;
        this.onlyShowFavorites = false;
    }
}
